import PropTypes from 'prop-types';

const colorShape = PropTypes.oneOf([
  'scouting-blue',
  'scouting-red',
  'scouting-tan',
  'scouting-warm-gray',
  'scouting-red',
  'venturing-green',
  'exploring-deep-blue',
  'sea-scout-blue',
  'cub-scout-yellow',
  'white',
]);

export default colorShape;
